import React from 'react';
import { Button } from '../UI/Button';
import { Link } from 'react-router-dom';
interface FinalCTAProps {
  openPaymentForm?: () => void;
  scrollToAccessPoints?: () => void;
}
export const FinalCTA = ({
  openPaymentForm,
  scrollToAccessPoints
}: FinalCTAProps) => {
  return <section className="py-20 bg-gray-50" data-id="element-437" data-mp="1n8yragsuvnij">
      <div className="container mx-auto px-4 text-center" data-id="element-438" data-mp="1na9xen9rx7ct">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 max-w-3xl mx-auto line-reveal scroll-animate" data-id="element-439" data-mp="zj4h66zx8d1z">
          Stop Collecting Contacts. Start Building Connections That Change Your
          Future.
        </h2>
        <div className="scroll-animate-scale stagger-2" data-id="element-440" data-mp="19a8u7161dnu6">
          <Button className="text-lg px-8 py-4 shadow-lg" onClick={scrollToAccessPoints} data-id="element-441" data-mp="14ih4stym9o5m">
            Join Now for ₦20,000 (Founder's Rate)
          </Button>
        </div>
      </div>
    </section>;
};